import { type ITicketFirstResponseTimeData } from '../../../../interfaces/reports';

import { ticketsTimeDeserializer } from './time-deserializer';

export function ticketFirstResponseTimeDeserializer({ data }: any): ITicketFirstResponseTimeData {
  return {
    firstResponseTime: ticketsTimeDeserializer(data.firstResponseTime, 'first response time'),
  };
}
